import React from "react";

import Modal from "./Modal";
import { DOWNLOAD, OPTION_CLOSE } from "src/constants/images";
import { downloadImage } from "utils/downloadImage";

const ArtViewModal = ({ isVisible, onClose, image, name }) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay art-view"
      className=" px-3 py-4 art-view-modal position-relative text-center align-self-center d-flex justify-content-center align-items-center vh-100"
    >
      <span
        onClick={() => downloadImage(image, name)}
        onKeyPress={(e) => e.code == "Enter" && downloadImage(image, name)}
        className="download position-absolute"
      >
        <img src={DOWNLOAD.SOURCE} alt="download" />
      </span>
      <span
        onClick={() => onClose()}
        onKeyPress={(e) => e.code == "Enter" && onClose()}
        className="close position-absolute"
      >
        <img src={OPTION_CLOSE.SOURCE} alt="close" />
      </span>
      <img src={image} alt="art view" className="art" />
    </Modal>
  );
};

export default ArtViewModal;
